<template>
  <div>
    <div class="card-employee">
      <employee-card
        :employee="employee"
      />
    </div>
    <div class="mt-2 mb-4 d-flex justify-content-between">
      <div class="statistic-attendance mr-2">
        <b-card>
          <modal-attendance-statistic-employees
            :attendanceType="attendanceType"
            :attendanceDataPerMonth="attendancePerMonth"
          />
        </b-card>
      </div>
      <div class="table-end-contract ml-2">
        <b-card>
          <data-contract-employee
            :contractProbationEmployee="concatTwoArray(employee.employeeTemporary, employee.employeeProbation)"
          />
        </b-card>
      </div>
    </div>
    <div>
      <b-row>
        <b-col
          v-for="summary in summaryListTop"
          :key="summary.status"
        >
          <b-card>
            <b-card-title class="font-weight-bold number">{{ summary.count !== null ? summary.count : 'N/A' }}</b-card-title>
            <b-card-text class="font-weight-bold title">{{ summary.status ? summary.status : '-' }}</b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="summary in summaryListBot"
          :key="summary.status"
        >
          <b-card>
            <b-card-title class="font-weight-bold number">{{ summary.count !== null ? summary.count : 'N/A' }}</b-card-title>
            <b-card-text class="font-weight-bold title">{{ summary.status ? summary.status : '-' }}</b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <recent-project />
        </b-col>
        <b-col>
          <invoice-list />
        </b-col>
        <b-col>
          <recent-notifications />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import RecentProject from './RecentProject.vue'
import InvoiceList from './InvoiceList.vue'
import RecentNotifications from './RecentNotifications.vue'
import EmployeeCard from './EmployeeCards.vue'
import DataContractEmployee from '@/components/DataContractEmployee.vue'
import ModalAttendanceStatisticEmployees from '@/components/ModalAttendanceStatisticEmployees.vue'

export default {
  components: { RecentProject, RecentNotifications, InvoiceList, EmployeeCard, ModalAttendanceStatisticEmployees, DataContractEmployee },
  data() {
    return {
      summaryListTop: [],
      summaryListBot: [],
      employee: {
        employeePermanent: [],
        employeeProbation: [],
        employeeTemporary: [],
        formerEmployee: []
      },
      employeeHasEndContract: [],
      notifiedEmployees: new Set(),
      attendanceType: [],
      attendancePerMonth: [],
      dataSet: []
    }
  },
  created() {
    this.fetchProject()
    this.getEmployeeByPosition('karyawan')
    this.getEmployeeByPosition('kontrak')
    this.getEmployeeByPosition('resign')
    this.getEmployeeByPosition('probation')
    this.getAttendanceType()
    this.getAttendancePerMonth()
  },
  watch: {
    employee: {
      handler() {
        this.employeeHasEndContract = this.concatTwoArray(this.employee.employeeProbation, this.employee.employeeTemporary)
      },
      deep: true
    },
    employeeHasEndContract: {
      handler() {
        this.employeeHasEndContract.forEach(employee => {
          if (
            employee.resignDate !== this.defaultDateFormated() &&
            !this.notifiedEmployees.has(employee.id)
          ) {
            this.notificationEmployeeEndContract(employee)
            this.notifiedEmployees.add(employee.id)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    async fetchProject() {
      const { data } = await api.dashboard.listProject()
      this.summaryList = data.data
      for (let i = 0; i < data.data.length; i++) {
        if (i < 4) {
          this.summaryListTop.push(data.data[i])
        } else {
          this.summaryListBot.push(data.data[i])
        }
      }
    },
    async getEmployeeByPosition(position) {
      const currentDate = new Date()
      const defaultDate = this.defaultDateFormated()
      let params = ''
      if (position === 'karyawan') {
        params = 'position==KARYAWAN||position==Karyawan, status==true'
      } else if (position === 'kontrak') {
        params = 'position==KONTRAK||position==Kontrak'
      } else if (position === 'resign') {
        params = 'status==false'
      } else if (position === 'probation') {
        params = 'position==PROBATION'
      }
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 1000000,
          Filters: params
        })
        if (position === 'karyawan') {
          this.employee.employeePermanent = data.data
        }
        if (position === 'probation') {
          data.data.map(item => {
            if (item.resignDate === this.defaultDateFormated()) {
              this.employee.employeeProbation.push(item)
            } else if (item.resignDate >= this.formatedDate(currentDate)) {
              this.employee.employeeProbation.push(item)
            }
          })
        }
        if (position === 'resign') {
          data.data.map(item => {
            if (item.resignDate < this.formatedDate(currentDate)) {
              this.employee.formerEmployee.push(item)
            }
          })
        }
        if (position === 'kontrak') {
          data.data.map(item => {
            if (item.resignDate > this.formatedDate(currentDate) || item.resignDate === defaultDate) {
              this.employee.employeeTemporary.push(item)
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getAttendancePerMonth() {
      const currentMonth = new Date().getMonth() + 1
      const currentYear = new Date().getFullYear()
      const lastDateMonth = new Date(currentYear, currentMonth, 0).getDate()
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 1000000,
          Filters: `attendanceDate>=${currentYear.toString()}-${currentMonth.toString().padStart(2, '0')}-01,attendanceDate<=${currentYear.toString()}-${currentMonth.toString().padStart(2, '0')}-${lastDateMonth}`
        })
        this.attendancePerMonth = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getAttendanceType() {
      try {
        const { data } = await api.presence.getTypeAttendance()
        this.attendanceType = data.data
      } catch (error) {
        console.log(error)
      }
    },
    notificationEmployeeEndContract(employee) {
      const endDate = new Date(employee.resignDate)
      const currentDate = new Date()
      const timeDifference = endDate.getTime() - currentDate.getTime()
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24))

      if (daysDifference >= 0 && daysDifference <= 14) {
        this.$bvToast.toast(`${employee.fullName} will end contract in ${daysDifference} days`, {
          title: 'End Contract',
          variant: 'warning',
          autoHideDelay: 5000,
          solid: true
        })
      }
    },
    concatTwoArray(arr1, arr2) {
      const newArr = [...arr1, ...arr2]
      return newArr
    },
    formatedDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    defaultDateFormated() {
      const customDate = new Date(1, 0, 1, 0, 0, 0)
      const month = (customDate.getMonth() + 1).toString().padStart(2, '0')
      const day = customDate.getDate().toString().padStart(2, '0')
      const hours = customDate.getHours().toString().padStart(2, '0')
      const minutes = customDate.getMinutes().toString().padStart(2, '0')
      const seconds = customDate.getSeconds().toString().padStart(2, '0')

      const formattedDate = `0001-${month}-${day} ${hours}:${minutes}:${seconds}`
      return formattedDate
    },
    convertStringMonthToNumber(data) {
      const month = data.split('-')[1]
      const monthNumber = parseInt(month)
      return monthNumber
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  font-size: 40px;
}
.title {
  font-size: 14px;
}

.statistic-attendance{
  width: 100vh;
}

.table-end-contract{
  width: 100vh;
}
</style>
